export default __webpack_public_path__ + "static/simple-doughnut-d4f469d484dcceb50ac7c1e5f5b61d72.png";